import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "../../Common/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../Common/Table";
import { debounce } from "../../Common/debounce";
import { getTransactionList } from "../../Redux/Slice/Transaction/GetTransactionListSlice";
import {
  setPage,
  setTotalItems,
  setTotalPages,
} from "../../Redux/Slice/Common/PaginationSlice";
import { dateFormat } from "../../Common/DateAndTimeFormat";
import { getTransactionByIdList, resetTransactionList } from "../../Redux/Slice/Transaction/GetTransactionsByIdSlice";
import { LIMIT_PER_PAGE, subscriptionType } from "../../Common/Constants";
import { Loader } from "../../Common/Loader";
import useDebounce from "../../Common/useDebounce";
import DateSelector from "../../Common/DateSelector";

export const TransactionHistory = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const searchQuery = useDebounce(searchText, 500);
  const [transactionsList, setTransactionsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [customerId, selectedCustomerId] = useState("");
  const [localItemsPerPage, setLocalItemsPerPage] = useState(LIMIT_PER_PAGE);

  const transactions = useSelector(
    (state) => state.transactionsById.transactions
  );
  const getTransactions = async (page = 1, limit) => {
    setIsLoading(true);
    let userId = props.stripeCustomerId
      ? props.stripeCustomerId
      : location.pathname.split("/")[2];
    const result = await dispatch(
      getTransactionByIdList({ id: userId, searchText: searchText, page, limit })
    );
    setIsLoading(false);
    await dispatch(setPage(result?.payload?.pagination?.currentPage));
    await dispatch(setTotalItems(result?.payload?.pagination?.totalItems));
    await dispatch(setTotalPages(result?.payload?.pagination?.totalPages));
  };

  const setPageList = (list) => {
    if (!!list) {
      return list.map((item, index) => {
        return {
          adminName: item?.adminName,
          companyName: item?.companyName,
          email: item?.email,
          planName: item?.planName,
          planType: item?.plan?.isTrial === true ? "Trial" : "Premium",
          interval: item?.interval,
          intervalLabel: item?.intervalLabel,
          purchaseDate: item?.purchaseDate ? item?.purchaseDate : "",
          credits: item?.credits,
          id: item?.id,
        };
      });
    }
  };
  useEffect(() => {
    let userId = location.pathname.split("/")[2];
    selectedCustomerId(userId);
    dispatch(resetTransactionList());
  }, []);
  useEffect(() => {
    if (transactions) {
      setTransactionsList(transactions.data);
    }else {
      setTransactionsList([]);
    }
  }, [transactions]);

  const debouncedGetTransactionsList = useCallback(
    debounce(getTransactions, 500),
    [searchQuery]
  );

  useEffect(() => {
    debouncedGetTransactionsList(1, localItemsPerPage);
  }, [searchQuery, debouncedGetTransactionsList]);

  const columns = [
    {
      label: "Plan Name",
      key: "planName",
      className: "profile",
    },
    {
      label: "Plan Type",
      key: "intervalLabel",
      className: "cellText",
    },
    {
      label: "Purchase Date",
      key: "purchaseDate",
      className: "cellText",
    },
    {
      label: "Credits",
      key: "credits",
      className: "cellText",
    },
  ];
  return (
    <>
      <div className="page__body">
        {isLoading ? <Loader /> : ""}
        <div className="tableWrap">
          <div className="tableWrap__head">
            <div className="formRow m_0 w_100 formRow--flexEnd">
              <div className="formCol formCol--flexInput">
                <div className="formCol flexField">
                  <input
                    className="form__input form__input--search"
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={e=>setSearchText(e.target.value)}
                  />
                </div>
                {/* <button className="btn btn__white">
                  <svg
                    width="20"
                    height="14"
                    viewBox="0 0 20 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.52637 7H15.5264M1.77637 1.5H18.2764M7.27637 12.5H12.7764"
                      stroke="#475569"
                      stroke-width="1.837"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Filter
                </button> */}
              </div>
              {/* <div className="formCol formCol--flex">
                <label for="date" className="form__label">
                  Date
                </label>
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__Field">
                      <DateSelector
                        placeholder="DD/MM/YYYY"
                      />
                    </div>
                  </div>
                  <div className="formCol">
                    <div className="form__Field">
                      <DateSelector
                        placeholder="DD/MM/YYYY"
                      />
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
            <Table
              data={setPageList(transactionsList)}
              columns={columns}
              hasAction="false"
            />
        </div>
      </div>
      <Pagination 
        apiMethod={getTransactions} 
        itemsPerPage={localItemsPerPage}
        setItemsPerPage={setLocalItemsPerPage}
      />
    </>
  );
};
